<template>
    <div class="card-home h-100">
        <div class="wrapper-blog">
            <div class="card-content-home">                
                <div>
                    <a :href="news.url" v-on:click="countStats(news.id)" target="_blank">
                        <div class="title is-6 has-text-weight-bold has-text-grey-dark line-height-medium mb-2">{{news.title}}</div>
                    </a>
                </div>
                <ul class="news-subitems mb-2">
                    <li v-for="n in 4" :key="n" class="news-subitem" v-show="news[`title${n}`]">
                        <span class="right-arrow-icon">➤</span>
                        <a :href="news[`url${n}`]" target="_blank">{{ news[`title${n}`] }}</a>
                    </li>
                </ul>
                <a :href="news.url" v-on:click="countStats(news.id)" target="_blank">
                    <div class="title is-7 has-text-grey is-italic">{{ newsDate }} | {{ news.site }}</div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
    name: "HomeFundNewsCard",
    props: {
        news: {
            type: Object,
            require: true
        }
    },
    computed: {
        newsDate() {
            return this.news.date ? moment(this.news.date).format('DD-MM-yyyy') : moment(this.news.created_at).format('DD-MM-yyyy');
        }
    },
    methods: {
        countStats(news_id){
            axios.post("/fundnewsrecapstats/" + news_id);
        }
    }
};
</script>
<style scoped lang="scss">
    .gap-20 {
        gap: 20px;
    }
    .news {
        &-title {
            font-weight: bold;
            font-size: 20px;
            text-decoration: underline;
        }
        &-summary {
            font-size: 16px;
            font-weight: 500;
            padding-bottom: 5px;
        }
        &-subitems {
            display: flex;
            flex-direction: column;
            gap: 3px;
        }
        &-subitem {
            display: flex;
            gap: 20px;
            font-size: 16px;
            a {
                text-decoration: underline;
            }
        }
    }
    .right-arrow-icon {
        font-size: 20px;
    }
    .news {
        width: 100%;

        &-date, &-source {
            &-desktop {
                display: block;
            }
            &-mobile {
                display: none;
            }
        }
    }
    @media (max-width: 767px) {
        .news {
            &-date, &-source {
                &-desktop {
                    display: none;
                }
                &-mobile {
                    display: block;
                    text-wrap: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
</style>